import { Route, Routes } from "react-router-dom";

import { Ceremonias, NuevaCeremonia, DetallesCeremonia } from "../pages";

export const CeremoniaRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Ceremonias />} />
      <Route path="/nueva" element={<NuevaCeremonia />} />
      <Route path="/:id" element={<DetallesCeremonia />} />
    </Routes>
  );
};
